import React from 'react';

import { CombinedInputs } from 'components/modules/Insurance/components/CombinedInputs/CombinedInputs';
import { VALUE_FIELDS } from 'store/carInstance/constants';

import { BrandSearcher } from '../BrandSearcher/BrandSearcher';
import { EnginePowerInput } from '../EnginePowerInput/EnginePowerInput';
import { EngineVolumeInput } from '../EngineVolumeInput/EngineVolumeInput';
import { MileageInput } from '../MileageInput/MileageInput';
import { ModelSearcher } from '../ModelSearcher/ModelSearcher';
import { PriceInput } from '../PriceInput/PriceInput';
import { VersionSearcher } from '../VersionSearcher/VersionSearcher';
import { YearSelect } from '../YearSelect/YearSelect';

import * as Constants from './OtherInformation.constants';
import { useOtherInformationPresenter } from './OtherInformation.presenter';
import * as S from './OtherInformation.styles';

export const OtherInformation = () => {
  const presenter = useOtherInformationPresenter();

  return (
    <>
      <S.FormWrapper>
        <S.VinOrBodyNumberInput
          labels={Constants.VIN_OR_BODY_NUMBER_LABELS}
          masks={Constants.VIN_OR_BODY_NUMBER_MASKS}
        />
        <S.SteeringWheelCheckbox />
        <BrandSearcher />
        <CombinedInputs>
          <ModelSearcher />
          {!presenter.hidden[VALUE_FIELDS.VERSION] && <VersionSearcher />}
        </CombinedInputs>
        <PriceInput />
        <YearSelect />
        <MileageInput />
        <EngineVolumeInput />
        <EnginePowerInput />
      </S.FormWrapper>
      <S.FormWrapper>
        <S.TypeOfUse />
      </S.FormWrapper>
    </>
  );
};
